import React from 'react';

export interface Props {
  Wrapper?: any;
  children: any;
}

class ConditionalWrapper extends React.Component<Props, any> {
  public render() {
    const { children, Wrapper, ...wrapperProps } = this.props;

    return Wrapper ? <Wrapper {...wrapperProps}>{children}</Wrapper> : children;
  }
}

export default ConditionalWrapper;
